module.exports = __webpack_public_path__ + "img/functional2-img7.b4ec6579.png";